import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Table } from 'antd'
import { isNil } from 'lodash'
import PropTypes from 'prop-types'

import { showErrorNotification } from '../../../core/helpers'
import { formatDateUk } from '../../../core/utils'

import { PAGINATION } from '../../../common/constants'

import { useMenuCurationTaskHistoryQuery } from '../../hooks'
import { StyledHistoryModal } from '../styled'

const MenuCurationTaskHistoryModal = ({ menuCurationTaskId }) => {
  const [isVisible, setIsVisible] = useState(false)
  const [currentPage, setCurentPage] = useState(PAGINATION.DEFAULT_PAGE)
  const [pageSize, setPageSize] = useState(PAGINATION.DEFAULT_PAGE_SIZE)

  const { data, isLoading, error } = useMenuCurationTaskHistoryQuery(
    menuCurationTaskId,
    {
      pageSize,
      currentPage,
    },
  )
  const { result, total } = data || {}

  useEffect(() => {
    if (error) {
      showErrorNotification({
        title: 'Failed to get history',
        description: error,
      })
    }
  }, [error])

  const handleChangePagination = useCallback(
    (page, size) => {
      setPageSize(size)
      setCurentPage(size !== pageSize ? PAGINATION.DEFAULT_PAGE : page)
    },
    [pageSize],
  )

  const paginationConfig = useMemo(() => {
    if (isNil(total)) {
      return false
    }

    return {
      current: Number(currentPage),
      pageSize,
      total,
      onChange: handleChangePagination,
      onShowSizeChange: handleChangePagination,
      pageSizeOptions: PAGINATION.DEFAULT_PAGINATION_SIZE_OPTIONS,
    }
  }, [total, currentPage, pageSize, handleChangePagination])

  const content = useMemo(() => {
    const columns = [
      {
        title: 'Description',
        dataIndex: 'description',
        key: 'description',
      },
      {
        title: 'User',
        dataIndex: 'user',
        key: 'user',
        render: user => user?.name,
      },
      {
        title: 'Created at',
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: date => date && formatDateUk(date),
      },
    ]

    return (
      <Table
        columns={columns}
        size="small"
        loading={isLoading}
        rowKey="id"
        dataSource={result}
        pagination={paginationConfig}
      />
    )
  }, [isLoading, paginationConfig, result])

  const handleCancel = useCallback(() => setIsVisible(false), [])
  const toggleModal = useCallback(() => setIsVisible(!isVisible), [isVisible])

  return (
    <>
      <StyledHistoryModal
        title="Menu curation task history"
        footer={null}
        visible={isVisible}
        wrapClassName="menu-curation-task-history-modal"
        onCancel={handleCancel}
      >
        {content}
      </StyledHistoryModal>
      <Button type="link" onClick={toggleModal}>
        {' '}
        View detailed history{' '}
      </Button>
    </>
  )
}

MenuCurationTaskHistoryModal.propTypes = {
  menuCurationTaskId: PropTypes.string.isRequired,
}

export default MenuCurationTaskHistoryModal
